<div class="footer-content p-5">
  <p>
    <small class="mb-0 text-muted text-center w-100 d-block">© 2022 Sinsim Liberty Private
      Limited All Right Reserved.</small>
  </p>
</div>